import React, { Fragment } from 'react';
import {Route, Routes } from 'react-router-dom';
import routes from './Routes/Routes';
import './App.css';
import ToastMessage from './Components/ToastMessage/ToastMessage';
const App = () => {
  return (
    <Fragment>
      <ToastMessage />
      <Routes>
          {routes?.map((elem, index) => {
            return (
              <Route
                key={index}
                exact={elem?.exact}
                path={elem?.path}
                element={elem?.component}
              />
            )
          })}
        </Routes>
    </Fragment>
  );
};

export default App;